// import React, { useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import {
//    Box,
//    Card,
//    CardBody,
//    Flex,
//    Text,
//    IconButton,
//    Menu,
//    MenuButton,
//    MenuList,
//    MenuItem,
//    Heading,
//    HStack,
//    VStack,
//    useDisclosure,
//    Center,
//    useColorMode, // Add this import
//    useColorModeValue, // Add this import
// } from '@chakra-ui/react';
// import { MoreVerticalIcon, PlusIcon } from 'lucide-react';
// import { ChevronLeftIcon } from '@chakra-ui/icons';
// import { deleteDaybook, getDaybook } from '../../../../../redux/actions/daybook';
// import { useDispatch, useSelector } from 'react-redux';
// import { useUser } from 'contexts';
// import DaybookForm from 'views/admin/masters/Pages/DaybookMaster/DaybookForm';
// import DeleteDialog from 'views/admin/masters/components/DeleteDialog';

// const ManageDaybook = () => {
//    const location = useLocation();
//    const dispatch = useDispatch();
//    const { isOpen, onOpen, onClose } = useDisclosure();
//    const [isEditMode, setIsEditMode] = React.useState(false);
//    const [currentRow, setCurrentRow] = React.useState(null);
//    const [selectedRowId, setSelectedRowId] = React.useState(null);
//    const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
//    const companyId = Number(localStorage.getItem('companyId'));
//    const daybooks = useSelector((state) => state.daybook?.list || []);
//    const [data, setData] = React.useState([...daybooks]);
//    const pathname = location.pathname;
//    const isDaybookRoute =
//       pathname.includes('/admin/bank/managedaybook') || pathname.includes('/admin/cash/managedaybook');

//    // Add color mode hooks
//    const { colorMode } = useColorMode();
//    const bgColor = useColorModeValue('gray.50', '#111C44');
//    const cardBg = useColorModeValue('white', 'gray.700');
//    const borderColor = useColorModeValue('gray.200', 'gray.600');
//    const dashedBorderColor = useColorModeValue('gray.300', 'gray.500');
//    const textColor = useColorModeValue('gray.700', 'gray.200');
//    const headingColor = useColorModeValue('gray.700', 'white');
//    const hoverBg = useColorModeValue('gray.50', 'gray.600');
//    const navigate = useNavigate();

//    // Get type and title based on route path
//    const getRouteConfig = () => {
//       const path = location.pathname.toLowerCase();

//       if (path.includes('/admin/sales/invoice/managedaybook')) {
//          return { type: 5, title: 'Sale / Manage Invoice Books' };
//       }
//       if (path.includes('/admin/sales/return/managedaybook')) {
//          return { type: 6, title: 'Sale / Manage Return Books' };
//       }
//       if (path.includes('/admin/purchase/invoice/managedaybook')) {
//          return { type: 11, title: 'Purchase / Manage Invoice Books' };
//       }
//       if (path.includes('/admin/purchase/return/managedaybook')) {
//          return { type: 12, title: 'Purchase / Manage Return Books' };
//       }
//       if (path.includes('/admin/bank/managedaybook')) {
//          return { type: 14, title: 'Bank / Manage Return Books' };
//       }
//       if (path.includes('/admin/cash/managedaybook')) {
//          return { type: 13, title: 'Cash / Manage Return Books' };
//       }
//       if (path.includes('/admin/inventory/issue/managedaybook')) {
//          return { type: 19, title: 'Issue / Manage Return Books' };
//       }
//       if (path.includes('/admin/inventory/receive/managedaybook')) {
//          return { type: 20, title: 'Receive / Manage Return Books' };
//       }
//       return { type: 5, title: 'Manage Daybooks' };
//    };

//    const { type, title } = getRouteConfig();
//    const { user } = useUser();

//    useEffect(() => {
//       if (!companyId) return;
//       dispatch(getDaybook({ companyId: user.loginhistory.companyId }));
//    }, [companyId, type, user, dispatch]);

//    const handleSave = (formData) => {
//       const dataWithType = { ...formData, type };

//       if (isEditMode && currentRow) {
//          setData(data?.map((row) => (row.id === currentRow.id ? { ...currentRow, ...dataWithType } : row)));
//       } else if (!isEditMode) {
//          setData([...data, { ...dataWithType, id: Date.now() }]);
//       }
//       onClose();
//       dispatch(getDaybook({ companyId: user.loginhistory.companyId }));
//    };

//    const handleEdit = (daybook) => {
//       setCurrentRow(daybook);
//       setIsEditMode(true);
//       onOpen();
//       dispatch(
//          getDaybook({
//             companyId: user?.loginhistory?.companyId
//          }),
//       );
//    };

//    const handleDeleteClick = (daybookId) => {
//       setSelectedRowId(daybookId);
//       setDeleteDialogOpen(true);
//    };

//    const handleDelete = async () => {
//       if (selectedRowId !== null) {
//          try {
//             await dispatch(deleteDaybook(selectedRowId));
//             await dispatch(
//                getDaybook({
//                   companyId: user?.loginhistory?.companyId
//                }),
//             );
//             setData(data.filter((row) => row.id !== selectedRowId));
//             setDeleteDialogOpen(false);
//          } catch (err) {
//             console.error('Failed to delete Daybook:', err);
//          }
//       }
//    };

//    const handleAddNew = () => {
//       setIsEditMode(false);
//       setCurrentRow(null);
//       onOpen();
//    };

//    return (
//       <>
//          <Box
//             bg={bgColor}
//             overflowY={'scroll'}
//             minH={isDaybookRoute ? { base: '85vh' } : { base: '80vh' }}
//             maxH={isDaybookRoute ? { base: '85vh' } : { base: '80vh' }}
//             mt='40px'
//             p={4}>
//             {/* Header */}
//             <HStack mb={6} spacing={4}>
//                <IconButton
//                   onClick={() => navigate(-1)}
//                   icon={<ChevronLeftIcon />}
//                   variant="ghost"
//                   aria-label="Back"
//                   size="lg"
//                />
//                <Heading size="md" color={headingColor}>
//                   {title}
//                </Heading>
//             </HStack>
//             {/* Daybooks Grid */}
//             <Flex gap={6} wrap="wrap">
//                {daybooks.filter((dd) => dd.type === type).map((data) => (
//                   <Card
//                      key={data.id}
//                      bg={cardBg}
//                      shadow="sm"
//                      borderRadius="md"
//                      border="1px"
//                      borderColor={borderColor}
//                      w={{ base: '100%', md: 'calc(50% - 12px)' }}
//                      maxW="400px">
//                      <CardBody p={6}>
//                         <Flex justify="space-between" align="center" mb={4}>
//                            <Heading size="sm" color={headingColor} fontWeight="semibold">
//                               {data.name}
//                            </Heading>
//                            <HStack spacing={2}>
//                               <Menu>
//                                  <MenuButton
//                                     as={IconButton}
//                                     icon={<MoreVerticalIcon />}
//                                     variant="ghost"
//                                     size="sm"
//                                     aria-label="More options"
//                                  />
//                                  <MenuList bg={cardBg}>
//                                     <MenuItem bg={cardBg} _hover={{ bg: hoverBg }} onClick={() => handleEdit(data)}>
//                                        Edit
//                                     </MenuItem>
//                                     <MenuItem
//                                        bg={cardBg}
//                                        _hover={{ bg: hoverBg }}
//                                        onClick={() => handleDeleteClick(data.id)}>
//                                        Delete
//                                     </MenuItem>
//                                  </MenuList>
//                               </Menu>
//                            </HStack>
//                         </Flex>

//                         <VStack align="stretch">
//                            <Flex gap={3}>
//                               <Text fontSize="sm" fontWeight={600} color={textColor} mb={2}>
//                                  Taxable Book :
//                               </Text>
//                               <Text fontSize="sm" fontWeight={600} color={textColor} mb={2}>
//                                  {data.applyGst ? 'Yes' : 'No'}
//                               </Text>
//                            </Flex>
//                         </VStack>
//                         <VStack align="stretch">
//                            <Flex gap={3}>
//                               <Text fontSize="sm" fontWeight={600} color={textColor} mb={2}>
//                                  No of Invoices :
//                               </Text>
//                               <Text fontSize="sm" fontWeight={600} color={textColor} mb={2}>
//                                  {data.applyGst}
//                               </Text>
//                            </Flex>
//                         </VStack>
//                         <VStack align="stretch">
//                            <Flex gap={3}>
//                               <Text fontSize="sm" fontWeight={600} color={textColor}>
//                                  Transaction Amount:
//                               </Text>
//                               <Text fontSize="sm" fontWeight={600} color={data.bal < 0 ? 'green.500' : 'red.500'}>
//                                  ₹ {Math.abs(data.bal)} {data.bal < 0 ? 'DB' : 'CR'}
//                               </Text>
//                            </Flex>
//                         </VStack>
//                      </CardBody>
//                   </Card>
//                ))}

//                {/* Add New Daybook Card */}
//                <Card
//                   bg={cardBg}
//                   shadow="sm"
//                   borderRadius="md"
//                   border="1px dashed"
//                   borderColor={dashedBorderColor}
//                   w={{ base: '100%', md: 'calc(50% - 12px)' }}
//                   maxW="400px"
//                   cursor="pointer"
//                   _hover={{ bg: hoverBg }}
//                   onClick={handleAddNew}>
//                   <CardBody p={6}>
//                      <Center h="100%" minH="150px">
//                         <VStack spacing={2}>
//                            <PlusIcon size={24} color={colorMode === 'light' ? 'gray.500' : 'gray.300'} />
//                            <Text fontSize="sm" fontWeight={600} color={textColor}>
//                               Add New Daybook
//                            </Text>
//                         </VStack>
//                      </Center>
//                   </CardBody>
//                </Card>
//             </Flex>
//          </Box>
//          <DaybookForm
//             isOpen={isOpen}
//             onClose={onClose}
//             isEditMode={isEditMode}
//             currentRow={currentRow}
//             onSave={handleSave}
//             type={type}
//          />

//          <DeleteDialog
//             isDeleteDialogOpen={isDeleteDialogOpen}
//             setDeleteDialogOpen={setDeleteDialogOpen}
//             handleDelete={handleDelete}
//             title="daybook"
//          />
//       </>
//    );
// };

// export default ManageDaybook;

import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
   Box,
   Card,
   CardBody,
   Flex,
   Text,
   IconButton,
   Menu,
   MenuButton,
   MenuList,
   MenuItem,
   Heading,
   HStack,
   VStack,
   useDisclosure,
   Center,
   useColorMode,
   useColorModeValue,
} from '@chakra-ui/react';
import { MoreVerticalIcon, PlusIcon, FileText, TrendingUp, DollarSign } from 'lucide-react';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import { deleteDaybook, getDaybook } from '../../../../../redux/actions/daybook';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'contexts';
import DaybookForm from 'views/admin/masters/Pages/DaybookMaster/DaybookForm';
import DeleteDialog from 'views/admin/masters/components/DeleteDialog';

const ManageDaybook = () => {
   const location = useLocation();
   const dispatch = useDispatch();
   const { user } = useUser();
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [isEditMode, setIsEditMode] = React.useState(false);
   const [currentRow, setCurrentRow] = React.useState(null);
   const [selectedRowId, setSelectedRowId] = React.useState(null);
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
   const companyId = Number(localStorage.getItem('companyId'));
   const daybooks = useSelector((state) => state.daybook?.list || []);
   const [data, setData] = React.useState([...daybooks]);
   const pathname = location.pathname;
   const isDaybookRoute =
      pathname.includes('/admin/bank/managedaybook') || pathname.includes('/admin/cash/managedaybook');

   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const navigate = useNavigate();

   // Premium color scheme
   const bgGradient = isDark
      ? 'bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900'
      : 'bg-gradient-to-br from-gray-50 via-blue-50 to-gray-100';

   const cardBg = isDark
      ? 'bg-gray-800/80 backdrop-blur-lg border border-gray-700'
      : 'bg-white/80 backdrop-blur-lg border border-gray-200';

   const headerBg = isDark
      ? 'bg-gradient-to-r from-slate-800 via-gray-800 to-slate-900 border-b border-gray-700'
      : 'bg-gradient-to-r from-slate-700 via-slate-800 to-slate-900 border-b border-slate-600';

   const accentBorder = isDark ? 'border-l-4 border-blue-400' : 'border-l-4 border-blue-500';
   const successGradient = 'bg-gradient-to-r from-green-500 to-emerald-500';
   const warningGradient = 'bg-gradient-to-r from-amber-500 to-orange-500';
   const infoGradient = 'bg-gradient-to-r from-blue-500 to-cyan-500';

   const getRouteConfig = () => {
      const path = location.pathname.toLowerCase();

      if (path.includes('/admin/sales/challan/managedaybook')) {
         return { type: 4, title: 'Sale Challan Books', icon: '📊', color: 'from-blue-500 to-purple-600' };
      }
      if (path.includes('/admin/sales/invoice/managedaybook')) {
         return { type: 5, title: 'Sale Invoice Books', icon: '📊', color: 'from-blue-500 to-purple-600' };
      }
      if (path.includes('/admin/sales/return/managedaybook')) {
         return { type: 6, title: 'Sale Return Books', icon: '🔄', color: 'from-orange-500 to-red-600' };
      }
      if (path.includes('/admin/purchase/challan/managedaybook')) {
         return { type: 10, title: 'Purchase Challan Books', icon: '📥', color: 'from-green-500 to-teal-600' };
      }
      if (path.includes('/admin/purchase/invoice/managedaybook')) {
         return { type: 11, title: 'Purchase Invoice Books', icon: '📥', color: 'from-green-500 to-teal-600' };
      }
      if (path.includes('/admin/purchase/return/managedaybook')) {
         return { type: 12, title: 'Purchase Return Books', icon: '📤', color: 'from-purple-500 to-pink-600' };
      }
      if (path.includes('/admin/bank/managedaybook')) {
         return { type: 14, title: 'Bank Books', icon: '🏦', color: 'from-emerald-500 to-green-600' };
      }
      if (path.includes('/admin/cash/managedaybook')) {
         return { type: 13, title: 'Cash Books', icon: '💵', color: 'from-amber-500 to-yellow-600' };
      }
      if (path.includes('/admin/inventory/issue/managedaybook')) {
         return { type: 19, title: 'Issue Books', icon: '📦', color: 'from-cyan-500 to-blue-600' };
      }
      if (path.includes('/admin/inventory/receive/managedaybook')) {
         return { type: 20, title: 'Receive Books', icon: '📬', color: 'from-violet-500 to-purple-600' };
      }
      return { type: 5, title: 'Manage Daybooks', icon: '📚', color: 'from-gray-500 to-gray-700' };
   };

   const { type, title, icon, color } = getRouteConfig();


   useEffect(() => {
      if (!companyId) return;
      dispatch(getDaybook({ companyId: user.loginhistory.companyId, companyIds: user.loginhistory.companyId }));
   }, [companyId, type, user, dispatch]);

   const handleSave = (formData) => {
      const dataWithType = { ...formData, type };

      if (isEditMode && currentRow) {
         setData(data?.map((row) => (row.id === currentRow.id ? { ...currentRow, ...dataWithType } : row)));
      } else if (!isEditMode) {
         setData([...data, { ...dataWithType, id: Date.now() }]);
      }
      onClose();
      dispatch(getDaybook({ companyId: user.loginhistory.companyId, companyIds: user.loginhistory.companyId }));
   };

   const handleEdit = (daybook) => {
      setCurrentRow(daybook);
      setIsEditMode(true);
      onOpen();
      dispatch(
         getDaybook({
            companyId: user?.loginhistory?.companyId,
            companyIds: user?.loginhistory?.companyId,
         }),
      );
   };

   const handleDeleteClick = (daybookId) => {
      setSelectedRowId(daybookId);
      setDeleteDialogOpen(true);
   };

   const handleDelete = async () => {
      if (selectedRowId !== null) {
         try {
            await dispatch(deleteDaybook(selectedRowId));
            await dispatch(
               getDaybook({
                  companyId: user?.loginhistory?.companyId,
                  companyIds: user?.loginhistory?.companyId,
               }),
            );
            setData(data.filter((row) => row.id !== selectedRowId));
            setDeleteDialogOpen(false);
         } catch (err) {
            console.error('Failed to delete Daybook:', err);
         }
      }
   };

   const handleAddNew = () => {
      setIsEditMode(false);
      setCurrentRow(null);
      onOpen();
   };

   const filteredDaybooks = daybooks.filter((dd) => dd.type === type);

   return (
      <>
         <Box className={`min-h-screen ${bgGradient} p-6`}>
            {/* Premium Header */}
            <div
               className={`${isDark
                  ? 'bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 border-gray-700'
                  : 'bg-gradient-to-r from-sky-600 via-blue-500 to-blue-600 border-blue-400'
                  } rounded-2xl shadow-2xl mb-8 overflow-hidden border`}>
               <div className="p-8">
                  <div className="flex items-center justify-between">
                     <div className="flex items-center space-x-4">
                        <button
                           onClick={() => navigate(-1)}
                           className={`p-3 rounded-xl transition-all duration-300 ${isDark
                              ? 'bg-gray-700 hover:bg-gray-600 text-white'
                              : 'bg-white/20 hover:bg-white/30 text-white backdrop-blur-sm'
                              }`}>
                           <ChevronLeftIcon className="w-6 h-6" />
                        </button>
                        <div>
                           <div className="flex items-center space-x-3">
                              <span className="text-3xl text-white">{icon}</span>
                              <h1 className="text-3xl font-bold text-white">{title}</h1>
                           </div>
                           <p className={`mt-2 ${isDark ? 'text-gray-300' : 'text-blue-100'}`}>
                              Manage your daybooks efficiently and effectively
                           </p>
                        </div>
                     </div>

                     <div
                        className={`px-6 py-3 rounded-xl backdrop-blur-sm border ${isDark ? 'bg-gray-800/80 border-gray-600' : 'bg-white/20 border-white/30'
                           }`}>
                        <div className="flex items-center space-x-6 text-white">
                           <div className="text-center">
                              <div className="text-2xl font-bold">{filteredDaybooks.length}</div>
                              <div className={`text-sm ${isDark ? 'text-gray-400' : 'text-blue-100'}`}>Total Books</div>
                           </div>
                           <div className={`w-px h-12 ${isDark ? 'bg-gray-600' : 'bg-white/30'}`}></div>
                           <div className="text-center">
                              <div className="text-2xl font-bold">
                                 {filteredDaybooks.filter((d) => d.bal > 0).length}
                              </div>
                              <div className={`text-sm ${isDark ? 'text-gray-400' : 'text-blue-100'}`}>Active</div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            {/* Daybooks Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
               {filteredDaybooks.map((data, index) => (
                  <div
                     key={data.id}
                     className={`${cardBg} rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 ${accentBorder} group overflow-hidden`}>
                     <div className="p-6">
                        {/* Card Header */}
                        <div className="flex justify-between items-start mb-4">
                           <div className="flex items-center space-x-3">
                              <div
                                 className={`p-3 rounded-xl ${isDark ? 'bg-blue-900/30' : 'bg-blue-100'
                                    } group-hover:scale-110 transition-transform duration-300`}>
                                 <FileText className={`w-6 h-6 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                              </div>
                              <div>
                                 <h3
                                    className={`font-bold text-lg ${isDark ? 'text-white' : 'text-gray-900'
                                       } group-hover:text-blue-500 transition-colors duration-300`}>
                                    {data.name}
                                 </h3>
                                 <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                                    Book #{index + 1}
                                 </p>
                              </div>
                           </div>
                           {!user?.isExpired && (
                              <Menu>
                                 <MenuButton
                                    as={IconButton}
                                    icon={<MoreVerticalIcon />}
                                    variant="ghost"
                                    size="sm"
                                    aria-label="More options"
                                    className={`${isDark ? 'text-gray-400 hover:bg-gray-700' : 'text-gray-500 hover:bg-gray-100'
                                       } opacity-0 group-hover:opacity-100 transition-all duration-300`}
                                 />
                                 <MenuList
                                    className={`${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
                                       } rounded-xl shadow-2xl min-w-[120px]`}>
                                    <MenuItem
                                       className={`${isDark ? 'hover:bg-gray-700 text-gray-200' : 'hover:bg-gray-100 text-gray-700'
                                          } rounded-lg mb-1`}
                                       onClick={() => handleEdit(data)}>
                                       Edit Book
                                    </MenuItem>
                                    <MenuItem
                                       className={`${isDark ? 'hover:bg-red-900/30 text-red-400' : 'hover:bg-red-50 text-red-600'
                                          } rounded-lg`}
                                       onClick={() => handleDeleteClick(data.id)}>
                                       Delete
                                    </MenuItem>
                                 </MenuList>
                              </Menu>
                           )}
                        </div>

                        {/* Card Content */}
                        <div className="space-y-4 mt-6">
                           <div className="flex items-center justify-between p-3 rounded-lg bg-gradient-to-r from-slate-500/10 to-gray-500/10">
                              <div className="flex items-center space-x-2">
                                 <TrendingUp className={`w-4 h-4 ${isDark ? 'text-green-400' : 'text-green-600'}`} />
                                 <span className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                    Taxable Book
                                 </span>
                              </div>
                              <span
                                 className={`px-3 py-1 rounded-full text-xs font-bold ${data.applyGst
                                    ? `${successGradient} text-white`
                                    : `${isDark ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'}`
                                    }`}>
                                 {data.applyGst ? 'Yes' : 'No'}
                              </span>
                           </div>

                           <div className="flex items-center justify-between p-3 rounded-lg bg-gradient-to-r from-blue-500/10 to-cyan-500/10">
                              <div className="flex items-center space-x-2">
                                 <FileText className={`w-4 h-4 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                                 <span className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                    Invoice Count
                                 </span>
                              </div>
                              <span
                                 className={`px-3 py-1 rounded-full text-xs font-bold ${isDark ? 'bg-blue-900/50 text-blue-300' : 'bg-blue-100 text-blue-700'
                                    }`}>
                                 {data.applyGst || '0'}
                              </span>
                           </div>

                           <div className="flex items-center justify-between p-3 rounded-lg bg-gradient-to-r from-emerald-500/10 to-green-500/10">
                              <div className="flex items-center space-x-2">
                                 <DollarSign
                                    className={`w-4 h-4 ${data.bal < 0
                                       ? isDark
                                          ? 'text-green-400'
                                          : 'text-green-600'
                                       : isDark
                                          ? 'text-red-400'
                                          : 'text-red-600'
                                       }`}
                                 />
                                 <span className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                    Balance
                                 </span>
                              </div>
                              <span
                                 className={`px-3 py-1 rounded-full text-xs font-bold ${data.bal < 0 ? `${successGradient} text-white` : `${warningGradient} text-white`
                                    }`}>
                                 ₹{Math.abs(data.bal)} {data.bal < 0 ? 'DB' : 'CR'}
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
               ))}

               {/* Add New Card */}
               {!user?.isExpired && (
                  <div
                     className={`${cardBg} rounded-2xl border-2 border-dashed ${isDark ? 'border-gray-600 hover:border-blue-400' : 'border-gray-300 hover:border-blue-500'
                        } transition-all duration-500 transform hover:-translate-y-2 hover:shadow-2xl cursor-pointer group overflow-hidden`}
                     onClick={handleAddNew}>
                     <div className="p-8 h-full min-h-[280px] flex flex-col items-center justify-center text-center">
                        <div
                           className={`w-20 h-20 rounded-full ${isDark ? 'bg-blue-900/30 group-hover:bg-blue-900/50' : 'bg-blue-100 group-hover:bg-blue-200'
                              } flex items-center justify-center mb-4 transition-all duration-500 group-hover:scale-110`}>
                           <PlusIcon
                              className={`w-10 h-10 ${isDark ? 'text-blue-400' : 'text-blue-600'
                                 } transition-transform duration-500 group-hover:rotate-90`}
                           />
                        </div>

                        <h3
                           className={`text-xl font-bold mb-2 ${isDark ? 'text-white' : 'text-gray-900'
                              } group-hover:text-blue-500 transition-colors duration-300`}>
                           Create New Daybook
                        </h3>

                        <p
                           className={`${isDark ? 'text-gray-400' : 'text-gray-600'
                              } text-sm max-w-[200px] transition-colors duration-300`}>
                           Add a new daybook to manage your financial transactions
                        </p>

                        <div
                           className={`mt-4 px-4 py-2 rounded-full ${isDark ? 'bg-blue-900/30 text-blue-400' : 'bg-blue-100 text-blue-600'
                              } text-sm font-medium transition-all duration-300 group-hover:scale-105`}>
                           Click to Create
                        </div>
                     </div>
                  </div>
               )}
            </div>
         </Box>

         <DaybookForm
            isOpen={isOpen}
            onClose={onClose}
            isEditMode={isEditMode}
            currentRow={currentRow}
            onSave={handleSave}
            type={type}
         />

         <DeleteDialog
            isDeleteDialogOpen={isDeleteDialogOpen}
            setDeleteDialogOpen={setDeleteDialogOpen}
            handleDelete={handleDelete}
            title="daybook"
         />
      </>
   );
};

export default ManageDaybook;
